import { IManualCheckDisbursementData } from '../../../../../types/order/escrow/IManualCheckDisbursementData';
import { DateField, TextField } from '../../../../../ui-toolkit';
import React, { useMemo } from 'react';

export const CreateEditManualCheckDisbursementNumberDate: React.FC<{
  check: IManualCheckDisbursementData;
  fieldName: string;
  index: number;
  hasEditPermission: boolean;
}> = ({ check, fieldName, index, hasEditPermission }) => {
  const todayDate = useMemo(() => new Date().toISOString(), []);

  return (
    <>
      {check.id && <TextField name={`${fieldName}.${index}.checkNumber`} label={'Check Number'} readOnly />}
      {check.id && (
        <DateField
          name={`${fieldName}.${index}.sentAtDate`}
          maxDate={todayDate}
          label={'Mark As Sent On'}
          placeholder={'Select a date...'}
          readOnly={!hasEditPermission || check.checkDate === undefined}
        />
      )}
    </>
  );
};
